module.exports = __webpack_public_path__ + "media/images/new_logo-1953ff4f77f0004ae5211e0a61a57ec9.svg";